import { api } from "@/api/client";
import type { components } from "@/api/contract";
import { unwrap } from "@/api/errors";

export type VideoJob = components["schemas"]["VideoGeneration"];

/**
 * GET /v1/videos/jobs/{id} — one video generation's current state. The in-chat
 * `generate_video` tool resolves immediately with a `queued` job id; we poll
 * this to know when the video has actually been produced.
 */
export async function getVideoJob(id: string): Promise<VideoJob> {
  const res = unwrap(await api.GET("/v1/videos/jobs/{id}", { params: { path: { id } } }));
  return res.job ?? {};
}
